import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';

export type BackgroundColor = 'Light_Purple';

export type TextColor =
  | 'Nero'
  | 'Dark_Grey'
  | 'Light_Grey'
  | 'Dove_Grey'
  | 'Pelorous'
  | 'Bali'
  | 'White_Smoke'
  | 'White'
  | 'Bahamas'
  | 'Salmon'
  | 'Dark_salmon'
  | 'Alice_Blue'
  | 'Jade'
  | 'Charcoal'
  | 'Black'
  | 'Light_Black'
  | 'Grey_88'
  | 'Grey_33'
  | 'Light_Charcoal';

export type VariantType =
  | 'T1' // font-size 10px
  | 'T2' // font-size 12px
  | 'T3' // font-size 14px
  | 'T4' // font-size 16px
  | 'T5' // font-size 20px
  | 'T6' // font-size 24px
  | 'T7' // font-size 8px
  | 'T8' // font-size 32px
  | 'T9' // font-size 22px
  | 'T10' // font-size 18px
  | 'unset';

export type WeightType = 'regular' | 'bold';

export interface AssuredGiftsHeaderTextProps {
  text: string;
  textColor?: TextColor;
  backgroundColor?: BackgroundColor;
  variant?: VariantType;
  fontWeight?: WeightType;
  textTransform?: 'is-capitalized' | 'is-uppercase' | 'is-lowercase' | 'none';
  marginTop?: boolean;
  noRadius?: boolean;
  textAlign?: string;
  width?: string;
  height?: string;
  lineHeight?: string;
  alignDiv?: string;
}

const cx = classNames.bind(styles);

const AssuredGiftsHeaderText: React.FC<AssuredGiftsHeaderTextProps> = (
  props: AssuredGiftsHeaderTextProps
) => {
  const {
    text = '',
    textColor = 'Nero',
    backgroundColor = 'Light_Purple',
    variant = 'T2',
    fontWeight = 'regular',
    textTransform = 'none',
    marginTop = false,
    noRadius = false,
    textAlign = 'left',
    width = 'full',
    lineHeight = 'default',
    alignDiv = 'left-align'
  } = props;
  const divClasses = cx('AssuredGiftHeadingContainer', {
    [`${backgroundColor}`]: true,
    marginTop,
    noRadius,
    [`${textAlign}`]: true,
    [`${width}`]: true,
    [`${alignDiv}`]: true
  });

  const paraClasses = cx({
    [`${textColor}`]: true,
    [`${variant}`]: true,
    [`${fontWeight}`]: true,
    [`${textTransform}`]: true,
    [`${lineHeight}`]: true
  });

  return (
    <div className={divClasses}>
      <p className={paraClasses} aria-label={text}>{text}</p>
    </div>
  );
};

AssuredGiftsHeaderText.defaultProps = {
  textColor: 'Nero',
  backgroundColor: 'Light_Purple',
  variant: 'T2',
  fontWeight: 'regular',
  textTransform: 'none',
  marginTop: false,
  noRadius: false,
  textAlign: 'left',
  width: 'full',
  lineHeight: 'none',
  alignDiv: 'left-align'
};

export default AssuredGiftsHeaderText;
